module.exports = __webpack_public_path__ + "img/rating-3.b50c7fc2.png";